/**
 * Roster New-Session page — the session-less Shift Planner, served at
 * roster.{env}.tricorder.icu/sessions/new. The board stands alone (its reads
 * are team/shift reads, not session reads); the planner chat's first send
 * mints the session upstream — a session is created WITH its first message,
 * never empty — and onSessionCreated navigates into it.
 *
 * This page owns only the standalone chrome; everything roster lives in the
 * shared workspace (RosterWorkspace via the face binding).
 */

import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ChevronLeft } from 'lucide-react'
import { ReturnToMainAgent } from '@frontend/components/ReturnToMainAgent'
import { RosterPlannerConnected } from '../components/roster/RosterPlannerConnected'

export default function RosterNewSession() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="flex h-dvh flex-col bg-[var(--color-surface-canvas,#ffffff)]">
      <header className="flex shrink-0 items-center gap-2 border-b border-[var(--color-surface-border)] bg-[var(--color-surface-bg)] px-4 py-3 pt-[max(0.75rem,env(safe-area-inset-top))]">
        <ReturnToMainAgent />
        <button
          type="button"
          onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))}
          aria-label={t('common.back', 'Back')}
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-[var(--color-surface-mute)] transition active:scale-95 hover:bg-[var(--color-neutral-100)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-primary-500)]"
        >
          <ChevronLeft className="h-5 w-5" aria-hidden="true" />
        </button>
        <div className="min-w-0 flex-1">
          <h1 className="truncate text-[19px] font-semibold tracking-[-0.01em] text-[var(--color-surface-ink)]">
            {t('roster.newRoster', 'New roster')}
          </h1>
        </div>
      </header>

      <main className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <RosterPlannerConnected onSessionCreated={(s) => navigate(`/sessions/${s.id}`, { replace: true })} />
      </main>
    </div>
  )
}
